import { useEffect, useMemo, useState } from "react";
import { useLocation, useRouteMatch } from "react-router-dom";
import { getContextsForTabs } from "shared/constants/contextsForTabs";
import { getTabs } from "shared/pages/exploreHseContextsOldDeprecated/const/tabs";
import { AppTester, getCurrentContextName } from "supporting";
import useQueryState from "./useQueryState";

interface IContextTabs {
    tabs?: string[];
    initialTab?: string;
    context?: string;
    normalizeCtx?: string;
    tags?: any[];
    additionalTabs?: Record<string, string>;
    requiredTags?: string[];
}


export const useContextsTabs = (): IContextTabs => {
    const [{ tab, additionalTab }] = useQueryState();
    const [context, setContext] = useState<string>('');
    const [normalizeCtx, setNormalizeCtx] = useState<string>('')
    const location = useLocation();
    const appName = getCurrentContextName();
    const isDesignMain = AppTester.isDeziiign();
    const isGeo = AppTester.isGeograffee();
    const [tabsList, contextTags, initialTab, additionalTabs ] = getTabs(context ?? '');
    const isTeam = useRouteMatch('/teams/:id');
    

    const tabs = useMemo(
        () => ((tabsList && !!Object.keys(tabsList)?.length && initialTab !== '') 
        ? {
            tabs: Object.keys(tabsList),
            initialTab,
            context,
            normalizeCtx,
            tags: contextTags,
            additionalTabs,
        }
        : { context }),
        [tabsList, initialTab, context, normalizeCtx, additionalTabs, contextTags]
    )

    useEffect(() => {
        const isPeopleOrProfile = location.pathname.startsWith('/designer') || location.pathname.startsWith('/context/hse');
        if(appName === 'hsedesign' || isPeopleOrProfile) {

            //todo make less complicated
            let ctx = location.pathname === '/' ? 'hsedesign_main' : 
                isTeam ? location.pathname.split("/")[location.pathname.split("/")?.length - 1] : 
                location.pathname?.slice(1, location.pathname?.length)
            ;

            const ctxForTabs = getContextsForTabs(ctx?.replace(/\//g, ''));

            const prevCtx = localStorage.getItem('currentCtx');

            setContext(ctxForTabs === '' ? (prevCtx ?? '') : ctxForTabs)
            setNormalizeCtx(ctx === '' ? (prevCtx ?? '') : ctx)
        } else {
            setContext(getContextsForTabs(appName))
        }
    }, [tab, additionalTab, appName, isGeo, location, isDesignMain])

    useEffect(() => {
        if (context !== '') {
            localStorage.setItem('currentCtx', context.toString());
        }
    }, [context])

    //@ts-ignore
    return tabs;
}import { useEffect, useMemo, useState } from "react";
import { useLocation, useRouteMatch } from "react-router-dom";
import { getContextsForTabs } from "shared/constants/contextsForTabs";
import { getTabs } from "shared/pages/exploreHseContextsOldDeprecated/const/tabs";
import { AppTester, getCurrentContextName } from "supporting";
import useQueryState from "./useQueryState";

interface IContextTabs {
    tabs?: string[];
    initialTab?: string;
    context?: string;
    normalizeCtx?: string;
    tags?: any[];
    additionalTabs?: Record<string, string>;
    requiredTags?: string[];
}


export const useContextsTabs = (): IContextTabs => {
    const [{ tab, additionalTab }] = useQueryState();
    const [context, setContext] = useState<string>('');
    const [normalizeCtx, setNormalizeCtx] = useState<string>('')
    const location = useLocation();
    const appName = getCurrentContextName();
    const isDesignMain = AppTester.isDeziiign();
    const isGeo = AppTester.isGeograffee();
    const [tabsList, contextTags, initialTab, additionalTabs ] = getTabs(context ?? '');
    const isTeam = useRouteMatch('/teams/:id');
    

    const tabs = useMemo(
        () => ((tabsList && !!Object.keys(tabsList)?.length && initialTab !== '') 
        ? {
            tabs: Object.keys(tabsList),
            initialTab,
            context,
            normalizeCtx,
            tags: contextTags,
            additionalTabs,
        }
        : { context }),
        [tabsList, initialTab, context, normalizeCtx, additionalTabs, contextTags]
    )

    useEffect(() => {
        const isPeopleOrProfile = location.pathname.startsWith('/designer') || location.pathname.startsWith('/context/hse');
        if(appName === 'hsedesign' || isPeopleOrProfile) {

            //todo make less complicated
            let ctx = location.pathname === '/' ? 'hsedesign_main' : 
                isTeam ? location.pathname.split("/")[location.pathname.split("/")?.length - 1] : 
                location.pathname?.slice(1, location.pathname?.length)
            ;

            const ctxForTabs = getContextsForTabs(ctx?.replace(/\//g, ''));

            const prevCtx = localStorage.getItem('currentCtx');

            setContext(ctxForTabs === '' ? (prevCtx ?? '') : ctxForTabs)
            setNormalizeCtx(ctx === '' ? (prevCtx ?? '') : ctx)
        } else {
            setContext(getContextsForTabs(appName))
        }
    }, [tab, additionalTab, appName, isGeo, location, isDesignMain])

    useEffect(() => {
        if (context !== '') {
            localStorage.setItem('currentCtx', context.toString());
        }
    }, [context])

    //@ts-ignore
    return tabs;
}